import * as React from 'react';
/**
 *
 * Original name: emoji sunglasses
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1093
 *
 */
export const EmojiSunglassesLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Zm0 14.5c-4.374 0-6.5-2.126-6.5-6.5 0-4.374 2.126-6.5 6.5-6.5 4.374 0 6.5 2.126 6.5 6.5 0 4.374-2.126 6.5-6.5 6.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M15 8.5a1.905 1.905 0 0 0-1.69.824 2.81 2.81 0 0 0-2.62 0A1.905 1.905 0 0 0 9 8.5a1.857 1.857 0 0 0-2 2 1.857 1.857 0 0 0 2 2 1.824 1.824 0 0 0 1.944-1.48l.016-.02a1.332 1.332 0 0 1 2.079 0l.017.02A1.825 1.825 0 0 0 15 12.5a1.857 1.857 0 0 0 2-2 1.858 1.858 0 0 0-2-2Zm-1.5 5.75a.75.75 0 0 1-.75.75H10.5v1.5h2.25A2.25 2.25 0 0 0 15 14.25V14h-1.5v.25Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
